module.exports = function(exec){
  try {
    exec();
    return false;
  } catch(e){
    return true;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.throws.js
 ** module id = 25
 ** module chunks = 0
 **/